import type { CollabListRow } from "@creators/backend/lib/collabs/queries";
import { isHiddenSystemMessage, parseSystemEvent } from "./system-events";

/**
 * One-line summary of where a thread left off, for inbox rows.
 *
 * System lines read as "You accepted" rather than "The creator accepted": the
 * row is already scoped to one counterparty, so naming both sides is noise.
 */
export function collabPreview(collab: CollabListRow): string | null {
  const body = collab.lastMessageBody?.trim();
  if (!body) return null;

  const mine = collab.yourRole;
  const names = {
    creator: mine === "creator" ? "You" : collab.counterpartName,
    brand: mine === "brand" ? "You" : collab.counterpartName,
  };

  if (collab.lastMessageSender === "platform") {
    if (isHiddenSystemMessage({ sender: "platform", body })) return null;
    const event = parseSystemEvent(body, names, mine);
    return secondPerson(event.detail ? `${event.title} · ${event.detail}` : event.title);
  }

  const author = collab.lastMessageSender === mine ? "You" : collab.counterpartName;
  return `${author}: ${body.replace(/\s+/g, " ")}`;
}

/**
 * The shared event copy is written about named third parties, so dropping "You"
 * into it leaves the verb and the possessive disagreeing.
 */
function secondPerson(text: string): string {
  return text
    .replace(/\bYou's\b/g, "your")
    .replace(/\bYou has\b/g, "You have")
    .replace(/\bYou is\b/g, "You are");
}
